//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useListableProperties } from '@/api/legacy/useListableProperties';
import ClickOutside from '@/directives/ClickOutside';
import SimpleInput from '../shared/simpleInput';
import EditorHint from './EditorHint.vue';
import DpInput from './Input.vue';

export default {
  name: 'DpVisualTextEditor',
  components: {
    DpInput,
    EditorHint,
  },
  directives: {
    ClickOutside,
  },
  extends: SimpleInput,
  props: {
    hints: { type: Array, default: () => [] },
    propertyHintsOverride: { type: Array, default: null },
    isKpi: { type: Boolean, default: false },
    includePropertyHints: { type: Boolean, default: true },
    includeMonitorHints: { type: Boolean, default: true },
    hideCalculatedProperties: { type: Boolean, default: false },
    expressionMode: { type: Boolean, default: false },
    dropdownPosition: { type: String, default: 'right' },
    multiline: { type: Boolean, default: true },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },

  data() {
    return {
      showDropdown: false,
      searchTerm: null,
    };
  },
  computed: {
    componentType() {
      return this.multiline ? 'textarea' : 'input';
    },
    filteredHints() {
      const allHints = JSON.parse(JSON.stringify(this.hints));

      if (this.includeMonitorHints) {
        allHints.push({
          name: 'Rule',
          namespace: 'rule',
          icon: 'rule',
          hints: [
            { label: 'Name', value: 'name', help: 'Name of the rule' },
            { label: 'Timestamp', value: '$ts', help: 'Timestamp of this trigger' },
            { label: 'State', value: 'state', help: 'true/false<br>true: the trigger becomes true<br>false: the trigger is no longer true' },
            { label: 'URL', value: 'url', help: 'URL that will open the affected device(s) in DevicePilot' },
          ],
        });
      }

      if (this.includePropertyHints) {
        const getPropIcon = (p) => {
          if (p.isCalculated) return 'calculated';
          return p.metadata ? 'metadata' : 'telemetry';
        };

        const needsEscaping = /[%.]/g;
        const toHintObj = (p) => {
          let value = this.expressionMode ? p.field : p.name;
          if (!this.expressionMode && value.match(needsEscaping)) {
            value = `[${value}]`;
          }
          return {
            label: p.alias,
            value,
            icon: getPropIcon(p),
            isCalculated: p.isCalculated,
          };
        };

        const safeOverrideObject = ({ value, ...rest }) => {
          let safeValue = value;
          if (value.match(needsEscaping)) {
            safeValue = `[${value}]`;
          }
          return {
            ...rest,
            value: safeValue,
          };
        };

        const propertyHintSection = {
          name: this.isKpi ? 'KPI properties' : 'Device properties',
          namespace: this.isKpi ? 'kpi' : 'device',
          icon: 'metadata',
          hints: this.propertyHintsOverride
            ? this.propertyHintsOverride.map(safeOverrideObject)
            : this.listableProperties.map(toHintObj),
        };

        if (this.hideCalculatedProperties) {
          propertyHintSection.hints = propertyHintSection.hints.filter((p) => !p.isCalculated);
        }

        allHints.push(propertyHintSection);
      }

      let filteredHints = allHints;

      if (this.searchTerm) {
        filteredHints = allHints.map((s) => {
          const section = s;
          section.hints = section.hints.filter((hint) => {
            const searchString = `${hint.value.toLowerCase()} ${hint.label.toLowerCase()}`;
            return searchString.indexOf(this.searchTerm.toLowerCase()) > -1;
          });
          return section;
        });
      }

      return filteredHints;
    },
  },
  methods: {
    async toggleDropdown() {
      this.showDropdown = !this.showDropdown;

      if (this.showDropdown) {
        await this.$nextTick();
        this.$refs.filter.focus();
      }
    },
    hideDropdown() {
      this.showDropdown = false;
    },
    insert(hint, namespace = null) {
      let fullHint = hint;

      if (!this.expressionMode) {
        const value = namespace !== null ? `${namespace}.${hint}` : hint;
        fullHint = `{{ ${value} }}`;
      }

      let textarea = this.$refs.input;
      if (textarea.$refs) {
        textarea = textarea.$refs.input;
      }

      // IE support
      if (document.selection) {
        textarea.focus();
        const sel = document.selection.createRange();
        sel.text = fullHint;
      } else if (textarea.selectionStart || textarea.selectionStart === '0') {
        // FF, Chrome etc.
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, startPos)
            + fullHint
            + textarea.value.substring(endPos, textarea.value.length);

        // Move caret to the end of the added text
        textarea.focus();
        const endCaret = endPos + fullHint.length;
        textarea.setSelectionRange(endCaret, endCaret);
      } else {
        textarea.value += fullHint;
        textarea.focus();
      }
      this.handleInput({ target: { value: textarea.value } });
    },
  },
};
